import { useNavigate } from "react-router-dom";
import { Button } from "@/components/atoms/Buttons";
import * as S from "./MainBanner.style";
import ImgProfile from "@/styles/assets/img/img_profile.png";
import { ReactComponent as LogoBannerWhite } from "@/styles/assets/svg/logo_banner_white.svg";
import { ChildrenProfile } from "@/types/children_profile.types";
import { monthCalculater } from "@/lib/utils/monthCalculater";

interface MainBannerProps {
  selectedProfile?: ChildrenProfile;
}

export const MainBanner = ({ selectedProfile }: MainBannerProps) => {
  const navigate = useNavigate();

  return (
    <S.MainBanner>
      <S.BannerTitBox>
        <LogoBannerWhite width={110} height={26} />

        <div>
          우리 아이를 위한
          <br />
          종합 솔루션을 확인해요
        </div>
      </S.BannerTitBox>

      <S.ProfileCard>
        {/** 선택한 프로필 아이디가 있는 경우 최근 선택한 프로필이 보이도록 수정 */}
        {selectedProfile ? (
          <S.ProfileCardContent>
            <S.ProfileCardTitle>
              최근 업데이트된 우리아이 정보
            </S.ProfileCardTitle>
            <div>
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}/${selectedProfile?.profile_image.path}`}
                alt="사용자 프로필 이미지"
              />
              <S.ProfileInfo>
                <span>{selectedProfile?.name}</span>
                <div>
                  <span>
                    {`${monthCalculater(selectedProfile?.birth_date)}개월 `}
                    {selectedProfile?.gender === "male" ? "남아" : "여아"}
                  </span>
                  <span>총 학습시간</span>
                </div>
              </S.ProfileInfo>
            </div>
          </S.ProfileCardContent>
        ) : (
          <p
            style={{
              textAlign: "center",
              color: "#666",
              fontSize: "15px",
              fontWeight: "300",
              fontFamily: "Pretendard",
              lineHeight: "140%",
              margin: "10px 0",
              width: "100%",
            }}
          >
            지금 우리 아이의 분석을 시작해보세요!
          </p>
        )}

        <Button
          type="button"
          size="sm"
          layout="solid"
          color="primary100"
          // label="맞춤 분석 보러가기"
          label={
            selectedProfile
              ? `우리 아이 맞춤 분석 보러가기`
              : `우리 아이 프로필 추가하기`
          }
          // onClick={() => navigate("/mypage/analysis/total")}
          onClick={
            selectedProfile
              ? () => {
                  navigate("/auth/profile/select", {
                    state: { pageIndex: 0, navigate: "/mypage/analysis/total" },
                  });
                }
              : () => {
                  navigate("/auth/profile/form");
                }
          }
        />
      </S.ProfileCard>
    </S.MainBanner>
  );
};
